import { createContext } from 'react';
import { Language } from './Language';

export const LanguageContext = createContext<Language>('en');
